import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'templateCat',
    standalone: true
})
export class TemplateCategoryPipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case 0:
        return 'Portal'
      case 1:
        return 'Chrome Extension'
      default:
        return ''
    }
  }
}
